<template>
    <h1 class="survey-title" :class="[size, color]"><slot /></h1>
</template>
<script src="./Title.ts" lang="ts"></script>
<style lang="scss">
@import '@/variables';

.survey-title {
    font-weight: bold;
    font-weight: 500;
    margin-top: 0.25rem;
    font-size: 2rem;

    &.xl {
        font-size: 3rem;
        line-height: 3rem;
        margin-bottom: 4rem;
    }
}
</style>
